"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

require("../styles/_organisation-info-stage.scss");

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function EditOrganisationStage(_ref) {
  var children = _ref.children,
      title = _ref.title;
  return _react.default.createElement("div", {
    className: "organisation-info-stage"
  }, _react.default.createElement("div", {
    className: "organisation-info-stage__header"
  }, _react.default.createElement(_uiKit.Icon, {
    name: "shootstacolour",
    size: 40
  }), _react.default.createElement("h1", null, _react.default.createElement("strong", null, title))), children);
}

var _default = (0, _react.memo)(EditOrganisationStage);

exports.default = _default;